export class M3u8Adapter {
  /**
   * According the m3u8 RFC,
   * "Each line is a URI, is blank, or starts with the
   * character '#'.  Blank lines are ignored.  Whitespace MUST NOT be
   * present, except for elements in which it is explicitly specified."
   */
  static changeUrls(m3u8, absolutePath, queryParameters) {
    // Remove \r. Lines can end with either \n or \r\n
    // Either way, we always return \n
    const m3u8UnixEol = m3u8.replace(/\r/g, '');

    const m3u8Lines = m3u8UnixEol.split('\n');

    m3u8Lines.forEach((line, index) => {
      if (line === '') {
        return;
      }

      //  #EXT-X-MAP:<attribute-list>
      //  The following attributes are defined:
      //  URI
      //  BYTERANGE
      if (line.startsWith('#EXT-X-MAP:') || line.startsWith('#EXT-X-MEDIA:')) {
        m3u8Lines[index] = line.replace(
          /URI="(.+?)"/g,
          `URI="${absolutePath}/$1?${queryParameters}"`
        );

        return;
      }

      if (line.startsWith('#')) {
        return;
      }

      // URI!
      m3u8Lines[index] = `${absolutePath}/${line}?${queryParameters}`;
    });

    return m3u8Lines.join('\n');
  }

  /**
   * This function processes a m3u8 file and applies the function "processor"
   * for every subplaylist URI, ignoring the media URI
   * This applies to media playlists, or audio playlists
   *
   * @param {String} m3u8
   * @param {function(String): Promise<String>} processor
   */
  static async processPlaylists(m3u8, processor) {
    // Remove \r. Lines can end with either \n or \r\n
    // Either way, we always return \n
    const m3u8UnixEol = m3u8.replace(/\r/g, '');

    const m3u8Lines = m3u8UnixEol.split('\n');

    const processedM3u8Lines = m3u8Lines.map(async line => {
      if (line.startsWith('#EXT-X-MEDIA:')) {
        const uriRegex = /URI="(.+?)"/g;

        const result = uriRegex.exec(line);

        const newPlaylist = await processor(result[1]);

        return line.replace(/URI="(.+?)"/g, `URI="${newPlaylist}"`);
      }

      if (line.startsWith('#')) {
        return line;
      }

      // At this point, it's an uri: a playlist or a media file
      if (line.includes('.m3u8')) {
        return processor(line);
      }

      return line;
    });

    const resolvedProcessedM3u8Lines = await Promise.all(processedM3u8Lines);

    return resolvedProcessedM3u8Lines.join('\n');
  }
}
